import React, { useState, useEffect } from 'react'
import InputField from '../UI/Input/InputField';
import ButtonField from '../UI/Button/ButtonModalField';
import { Modal } from 'react-bootstrap';
import {MDBRow, MDBCol } from 'mdbreact';
import useValidator from '../../hooks/useValidator';
import { PostAPI } from '../../api/post';
import { useTranslation } from 'react-i18next';
import { FetchAPI } from '../../api/fetch';
import { Domain } from "environment/environment";
import swal from 'sweetalert';
import BeatLoader from "react-spinners/BeatLoader";
import Toggle from "react-toggle";
import "react-toggle/style.css"
import { isEmpty } from 'components/Login/validator';
import { Table } from "react-bootstrap";
import CustomSwitch from 'components/CustomSwitch/CustomSwitch';
import moment from 'moment';
import Cookies from 'universal-cookie';
import MultiFileUpload  from "components/MultiFileUpload/MultiFileUpload";
import FileUpload from "components/SingleFileUpload/FileUpload"
import FileList from "components/FileList/FileList";
import MultiFileList from "components/MultiFileList/MultiFileList"
const cookies = new Cookies();
let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;

const ModalBox = ( props ) => {
    const { t, i18n } = useTranslation();
    let[reason, setReason] = useState();
    let [tableList, setTableList] = useState([]);
    let [unique, setUnique] = useState([]);
    let [toggle,setToggle] = useState("Reference Id*")
    let [tdData, setTdData] = useState([]);
    let [disabled, setDisabled] = useState(false);
    let [material, setMaterial] = useState();
    const [readonly, setReadOnly] = useState(false);
    let [parentTableLength, setParentTableLength] = useState();
    let [qty, setQty] = useState();
    const [lat, setLat] = useState();
    const [lan, setLan] = useState();
    let [po_Number, setPO_number] = useState([]);
    let [quantity, setQuantity] = useState();
    let [product, setProduct] = useState();
    let [location, setLocation] = useState();
    let [formInputs, setFormInputs] = useState();
    let [form, setForm] = useState();
    let [productgroup, setProductgroup] = useState();
    let [price, setPrice] = useState();
    let [remarks, setRemarks] = useState();
    let [visible, setVisible] = useState(false);
    const [validator, showValidationMessage] = useValidator();
    const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
    let [center, setCenter] = useState({
        lat: 0, 
        lng: 0
    })
    let uniq;
    let data;
    let [selectedFile, setSelectedFile] = useState();
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [area, setArea] = useState('');
	const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [mapPosition, setMapPosition] = useState({
        lat: center.lat,
        lng: center.lng
	});
	const  [markerPosition, setMarkerPosition] = useState({
        lat: center.lat,
        lng: center.lng
    });
    let [unBind,setUnbind] = useState({
        delimiter : 'multiline',
        toggle : false
    })
    const titlesList = ['UnBind Serial Number','Assign Serial Number']
    let [passVal, setPassVal] = useState();
    let [fromDate, setFromDate] = useState();
    let [toDate, setToDate] = useState();
    let [ModalformValues, setModalformValues] = useState(props.formValue);
    let [loadSForm, setloadSForm] = useState(false);
    const [loading, setLoading] = useState(false);
    let [disabledButton, setDisabledButton] = useState(false);
    let [editFileUpload, setEditFileUpload] = useState()
    let [releaseNotes, setReleaseNotes] = useState();
    let [formFile, setFormFile] = useState();
    let [doclinks, setDocLinks] = useState();
    let [buildUrl, setBuildUrl] = useState();
    let [docUrl,setDocUrl] = useState([]);
    let [unBindValue,setUnBindValue] = useState('')
    let [edit, setEdit] = useState(false)
    let [editProp,setEditProp]=useState(false)
    let [staticModalformValues, setStaticModalformValues] = useState(props.buildValue);
    const [uploadFiles, setUploadFiles] = useState([])
    const [multiUploadFiles, setMultiUploadFiles] = useState([])
    const [buildInputVal,setBuildInputVal]=useState({})
    const [checked,setChecked]=useState(false)
    let [buildEdit, setBuildEdit] = useState(null)
    let [docEdit, setDocEdit] = useState(null)

    let commonval = '';
    let customerID = ['13','14','15']


    let centeredDiv = {
        display: 'flex',
        borderRadius: '15px',
        fontSize: '9px',
        position:'relative',
        alignItems: 'center',
    }

    let commonParams = {
        customer_id:cookies.get('customer_id'),
        user_id:cookies.get('user_id'),
        language:localStorage.getItem('i18nextLng') === 'en' ? 'english' : 'chinese'
    }

    const formElementsArray = [];
    for (let key in ModalformValues){
      formElementsArray.push({
        id: key,
        config: ModalformValues[key]
      });
    }

    const removeFile = (filename,type) => {
        if (props.titlePreFix == 'Edit') {
            if(type == "doc"){
                setDocEdit(0)
            }
            if(type == "build"){
                setBuildEdit(0)
            }
            setEditProp(true)
            setDocLinks(doclinks.filter((link) => decodeURIComponent(link.file).substring(decodeURIComponent(link.file).lastIndexOf('/') + 1) !== filename))
            setBuildUrl(buildUrl.filter(file => file.name !== filename))
            setDocUrl(docUrl.filter(file => file.name !== filename))
        } else {
            setUploadFiles(uploadFiles.filter(file => file.name !== filename))
            setMultiUploadFiles(multiUploadFiles.filter(file => file.name !== filename))

        }
    }

    const customModalFields = (formElementsArray) => {
        switch (props.title) {
            case 'UnBind Serial Number':
                return (
                    <>
                        {formElementsArray.map(formElement => (
                        <>
                        <MDBRow>
                            <MDBCol md="6" className="mb-6" key={formElement.id}>
                                        <label className="Label" htmlFor="lang">Delimiter/Seperator<span style={{color:"red",fontSize:'16px'}}>*</span></label>
                                        <select className="form-control" id="lang"
                                           disabled={true}
                                           onChange={(e) => {
                                            let newValue = e.target.value;
                                            if (newValue) {
                                              setUnbind((prevState) => ({ ...prevState, delimiter: newValue }));
                                            }
                                          }}
                                            value={unBind.delimiter}>
                                            <option value="mulitiLine">NewLine</option>
                                            <option value="comma">Comma(,)</option>
                                        </select>                           
                            </MDBCol>
                            <MDBCol md="6" className="mb-6">
                                        <span style={{ display: 'flex', alignItems: 'center', transform: 'translateY(3rem)' }}>
                                        Master Carton &nbsp;
                                            <CustomSwitch changed={() => 
                                             setUnbind(prevState => {
                                                return {
                                                  ...prevState,
                                                  toggle: !prevState.toggle
                                                }
                                              })
                                        }
                                        checked={unBind.toggle}>Unind</CustomSwitch>
                                        &nbsp; Gift Box
                                    </span>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                        <MDBCol md="6" className="mb-6">
                                <InputField
                                    key={formElement.id}
                                    elementType={formElement.config.elementType}
                                    elementConfig={formElement.config.elementConfig}
                                    value={unBindValue}
                                    labelName={formElement.config.label}
                                    id={formElement.config.id}
                                    isValidate={formElement.config.validate}
                                    changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                    validater={validator}
                                    titlePreFix={props.titlePreFix}
                                    title={props.title}
                                />
                        </MDBCol>
                        </MDBRow>
                        </>
                        ))}
                        <div className='button-container' style={{justifyContent:'flex-end',transform:'translateY(3rem)'}}>
                            <button onClick={clearUnBindValue} className="btn btn-outline-danger btn-rounded waves-effect" >{t("clear")}</button>
                            <button disabled={disabled} className="btn btn-outline-primary btn-rounded waves-effect" onClick={submitForm} >{t('submit')}</button>
                        </div>
                    </>
                );
            case 'Assign Serial Number':
                return (
                    <>
                        {formElementsArray.map(formElement => (
                        <MDBCol md="6" className="mb-6"
                            style={{ height: '82px' }}
                            key={formElement.id}>
                            <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={(formElement.config.value == null) ? '' : formElement.config.value}
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                validater={validator}
                                titlePreFix={props.titlePreFix}
                                title={props.title}
                                template={props.dyn_template}
                                passVal={passVal}
                                setPassVal={setPassVal}
                                tableList={tableList}
                                material={material}
                                setMaterial={setMaterial}
                                qty={qty}
                                setQty={setQty}
                                quantity={quantity}
                                setQuantity={setQuantity}
                                product={product}
                                setProduct={setProduct}
                            />
                        </MDBCol>
                        ))}
                    </>
                )
        }
    }
   
    const addTableData = (upd) => {
        if((tdData['material'] && tdData['material'] ===  `${t('please_select')}`))
        swal({title:`${t("alerts.choose_valid")}`, text:`${t("alerts.please_cannot_be_selected")}`, icon:"warning", button:`${t("alerts.ok")}`})
    const someProperty = {...upd}
    if(validator.allValid()) {
        Object.keys(someProperty).map(el => {
            if (((el === 'material' || el === 'qty') && (someProperty["material"]?.update?.endPoint === undefined && cookies.get('customer_id') !== '13')) || el === 'location' || el === 'product_group' || (props.title === "Purchase Order" && el === "product")){
            someProperty[el].value = '';
            }
            else if((props.commonTitle === "Download IOT's(Buffer)" || props.title === 'Reclamation Delivery')  && (el === "material" || el === "qty")){
            someProperty[el].value = '';
            }
            else if((props?.permission === false && props.commonTitle === 'Delivery' && someProperty["material"].update?.endPoint !== undefined && (cookies.get('customer_id') === '13' || cookies.get('customer_id') === '16')  && (el === 'material' || el === 'qty'))){
            someProperty[el].value = '';
            }
        })
        if(props.commonTitle!='Buffer Serial Number'){
        Object.keys(someProperty).map(el => {
            if(el === 'material' || el === 'qty' || el === 'location' || el === 'product_group'){
            if((props.commonTitle === 'Delivery' && typeof(someProperty['material'].value) === 'string' && tdData.material === undefined)){
                swal({title:`${t("alerts.add_values1")}`, text:`${t("alerts.material_table")}`, icon:"warning", button:`${t("alerts.ok")}`})
            }else if(props.commonTitle === 'AttributeSets' && tdData.product_group === undefined )
            swal({title:`${t("alerts.add_values1")}`, text:`${t("alerts.product_grp_table")}`, icon:"warning", button:`${t("alerts.ok")}`})
            }else if(props.commonTitle === "Assign Serial Number" && typeof(someProperty['product'].value) === 'string' && tdData.product  == undefined){
                swal({title:`${t("alerts.add_values1")}`, text:`${t("alerts.product_table")}`, icon:"warning", button:`${t("alerts.ok")}`})
            }
        })
    }
        if (props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
            Object.keys(someProperty).map(el => {
                if ((el === 'Primary - Gift Box Quantity') || (el === 'product')) {
                    if (typeof (someProperty['product'].value) === 'string') {
                        swal({ title: `${t("alerts.add_values1")}`, text: `${t("alerts.product_table")}`, icon: "warning", button: `${t("alerts.ok")}` })
                    }
                    else if (typeof (someProperty['product'].value) === 'string' || someProperty['Primary - Gift Box Quantity'].value == "") {
                        swal({ title: `${t("alerts.add_values1")}`, text: `${t("alerts.quantity_table")}`, icon: "warning", button: `${t("alerts.ok")}` })
                    }
                }
            }
         )}

        if(props.commonTitle === 'AttributeSets') {
            for(var i = 0; i < tableList.length; i++) {
                if (tableList[i].product_group == tdData.product_group
                    && tableList[i].location == tdData.location) {
                swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.already_assigned_to_location")}`, icon:"error", button:`${t("alerts.ok")}`})
                    }
                }
                setTdData([])
        }

        if (props.commonTitle === "Purchase Order") {
            for (var i = 0; i < tableList.length; i++) {
                if (tableList[i].product == tdData.product) {
                    swal({ title: `${t("alerts.duplicate_values")}`, text: `product is already assigned to location`, icon: "error", button: `${t("alerts.ok")}` })
                    return;
                }
            }
            setTdData([]);
        }

        if(props.title === "Reclamation Delivery"){
            if(tableList.length == 0){
                setReadOnly(true)
            }else{
                setReadOnly(false)

            }
        }
        if(props.commonTitle === "Download IOT's(Buffer)") {
            for(var i = 0; i < tableList.length; i++) {
                if (tableList[i].po_number == tdData.po_number
                    && tableList[i].material == tdData.material) {
                swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.already_assigned_to_material")}`, icon:"error", button:`${t("alerts.ok")}`})
                        setTdData([])
                    }
                }
        }
            if(props.commonTitle === 'Pick List') {
                Object.keys(someProperty).map(el => {
                    if((el === 'deliveries') || (el === 'from_location'))
                    if(someProperty[el].elementType === 'multiselect') {
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            someProperty[el].value.map(function(fValue, indexId){
                                arrayConvert[indexId] = fValue.value;
                            tdData[el] = arrayConvert
                            });
                        }
                    }
                    if(el === 'deliveries' && someProperty[el].update.required == true){
                        if(tableList.length == 0){
                            let getURL = someProperty[el].update.endPoint;
                            updateEndPoint(getURL, tdData);
                        }
                        else {
                            const deliveryArray = [];
                            tableList.map(ele => {
                                if (deliveryArray.indexOf(ele.delivery_no) === -1) {
                                    deliveryArray.push(ele.delivery_no)
                                }
                            })
                            if( deliveryArray.length === tdData['deliveries'].length && 
                            deliveryArray.every(item => tdData['deliveries'].indexOf(item) > -1))
                                console.log("@@matched");
                            else {
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData);
                            }
                        }
                    }
                })
            }
            if(props.commonTitle === "Vendor Serial Number" || props.commonTitle === 'Reclamation PO'){
                Object.keys(someProperty).map(el => {
                    if((el === 'po_number'))
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(someProperty[el].value)
                            tdData[el] = arrayConvert
                        }
                        
                    })
                    Object.keys(someProperty).map(el => {
                        if((el === 'po_number' && someProperty[el].update.required == true )){
                            if(tableList.length == 0){
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                        }
                    })
                    setDisabled(true)
            }
            if(props.commonTitle === "Revert Assigned Serial Number") {

                // for setting data in tdData
                Object.keys(someProperty).map(el => {

                    tdData[el] =[someProperty[el].value];
                });
                // to make api call
                Object.keys(someProperty).map(el => {

                    if(tableList.length == 0 &&  el == 'product'){
                      let getURL = someProperty[el].update.endPoint;

                        updateEndPoint(getURL, tdData, someProperty);

                    }else if(tableList.length !== 0 ){

                        // Handling the dublicate values;
                        const prodArray = [];
                        const tbData = []
                        let data = Array.from(tdData['product'])
                        data.map((fvalue,indexId) => {
                            tbData[indexId] = fvalue.label
                        })
                        tableList= tableList.filter((e)=>e!=undefined||e!=null)
                        tableList.map(ele => {
                            if (prodArray.indexOf(ele.product) === -1) {
                                prodArray.push(ele.product)
                            }
                        })
                        if(prodArray.some(item => tbData.includes(item))){
                            swal({title:`${t("alerts.already_product")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})
                        }
                    else {
                        if(someProperty[el].id==="product"){
                            let getURL = someProperty[el].update.endPoint;
                            updateEndPoint(getURL, tdData, someProperty);
                        }
                        }
                    }
                });
            }
            if(props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
                Object.keys(someProperty).map(el => {
                if((el === 'Primary - Gift Box Quantity') || (el === 'product')){
                    if((someProperty[el].value)) {
                        let arrayConvert = [];
                        arrayConvert.push(someProperty[el].value)
                        tdData[el] = arrayConvert
                    }
                }   
                })
                Object.keys(someProperty).map(el => {
                    if((el === 'Primary - Gift Box Quantity') || (el === 'product')){
                    if((el === 'product' && someProperty[el].update.required == true )){
                        if(tableList.length == 0 && someProperty['product'].value !== null){
                            let getURL = someProperty[el].update.endPoint;
                            if(props.commonTitle === 'Assign Serial Number'){
                                ModalformValues['po_mode'].elementConfig.readonly = true
                            }
                            updateEndPoint(getURL, tdData, someProperty);
                        }
                        else if(tdData['product'] === undefined || tdData['Primary - Gift Box Quantity'] === undefined){
                            addTableAlerts(someProperty)
                        }
                        else if(tableList.length !== 0 && tdData['Primary - Gift Box Quantity'] !== undefined && tdData['product'] !== undefined ){
                            const prodArray = [];
                            const tbData = []
                            let data = Array.from(tdData['product'])
                            data.map((fvalue,indexId) => {
                                tbData[indexId] = fvalue.label
                            })
                            tableList.map(ele => {
                                if (prodArray.indexOf(ele.product) === -1) {
                                    prodArray.push(ele.product)
                                }
                            })
                            if(prodArray.some(item => tbData.includes(item))){
                                swal({title:`${t("alerts.already_product")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})
                            }
                        else {
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                        }
                    }
                }
            })
        }
            if(props.commonTitle === "Buffer Serial Number") {
                Object.keys(someProperty).map(el => {
                     if(el==="product"||el==="Quantity"){
                        tdData[el]= [someProperty[el].value]
                     }
                     if(el=="vendorId"){
                        tdData[el]= someProperty[el].value.value
                     }
            })
            Object.keys(someProperty).map(el => {
                if(el=="use_type" && tableList.length > 0){
                    let getURL = someProperty[el].update.endPoint; 
                    const test = po_Number.filter(item => item === po_Number[0])
                    if(typeof someProperty['product'].value === 'string' || JSON.stringify(tdData['Quantity']) === JSON.stringify([''])){
                        addTableAlerts(someProperty)
                    }else if(test[0] === ModalformValues['po_number'].value.value){
                        updateEndPoint(getURL, tdData, someProperty);
                    }else{
                        const span = document.createElement("span");
                        span.innerHTML = `Alert: Previous PO : <code>${test[0]}</code> is different from Selected PO :\n <code>${ModalformValues['po_number'].value.value}</code>`                                    
                        swal({
                                html: true,
                                title : 'Distinct PO cannot be added',
                                content: span,
                                icon: "info",
                                dangerMode: true,
                            })
                    }
                }
            })
            Object.keys(someProperty).map(el => {
                if((el === 'Primary - Gift Box Quantity') || (el === 'use_type')){
                    if(tableList.length !== 0){
                        const prodArray = [];
                        const tbData = []
                        let data = Array.from(tdData['product'])
                        data.map((fvalue,indexId) => {
                            tbData[indexId] = fvalue.label
                        })
                        tableList.map(ele => {
                            if (prodArray.indexOf(ele.product) === -1) {
                                prodArray.push(ele.product)
                            }
                        })
                        if(prodArray.some(item => tbData.includes(item))){
                            swal({ title: `${t("alerts.already_material")}`, text: `${t("alerts.duplicate_not_allowed")}`, icon: "warning", button: `${t("alerts.ok")}` });
                        }
                    }
                    else{
                        let getURL = someProperty[el].update.endPoint;
                       updateEndPoint(getURL, tdData, someProperty);
                    }
            }
        })
    }
    
            if((props?.permission === true && (cookies.get('customer_id') == '13' || cookies.get('customer_id') == '16'))|| (props.commonTitle === 'Delivery' && someProperty["material"].update?.endPoint !== undefined && (cookies.get('customer_id') !== '13' && cookies.get('customer_id') !== '16'))) {
                Object.keys(someProperty).map(el => {
                    if((el === 'material')){
                        if((someProperty[el].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(someProperty['material'].value)
                            tdData[el] = arrayConvert
                            tdData["qty"] = someProperty['qty'].value
                        }
                    }
                    })
                    Object.keys(someProperty).map(el => {
                        if((el === 'material' && someProperty[el].update.required == true )){
                            if(tableList.length == 0 && someProperty['material'].value !== null){
                                let getURL = someProperty[el].update.endPoint;
                                updateEndPoint(getURL, tdData, someProperty);
                            }
                            else if(tableList.length !== 0 && tdData.material !== undefined) {
                                const matArray = [];
                                const tbData = []
                                let data = Array.from(tdData['material'])
                                data.map((fvalue,indexId) => {
                                    tbData[indexId] = fvalue.label
                                })
                                tableList.map(ele => {
                                    if (matArray.indexOf(ele.material) === -1) {
                                        matArray.push(ele.material)
                                    }
                                })
                                if(matArray.some(item => tbData.includes(item))){
                                swal({title:`${t("alerts.already_material")}`, text:`${t("alerts.duplicate_not_allowed")}`, icon:"warning", button:`${t("alerts.ok")}`})        
                                }
                            else {
                                    let getURL = someProperty[el].update.endPoint;
                                    updateEndPoint(getURL, tdData, someProperty);
                                }
                            }
                        }
                    })
            }
        setTableList((tableList) => tableList.concat(tdData));
    }   
    else{
        showValidationMessage(true);
    }
    }
   
    function getKeysYML(){
        if(props.headers !== null)
            return Object.values(props.headers);
        }

    function getHeader(){
        let keys = getKeysYML();
        return keys.map((key, index)=>{
                return i18n.language === "chi" ? <th key={key}>{key["text"].toUpperCase()}</th> : <th key={key}>{key.toUpperCase()}</th>
            })
    } 
    
    function addTableAlerts(someProperty) {
        let title, text;
        switch (props.commonTitle) {
            case 'Assign Serial Number':
            case 'Reclamation Assign PO':
                const isProductUndefined = tdData['product'] === undefined;
                title = isProductUndefined ? 'Choose valid Product' : "Provide the selected product's quantity";
                text = isProductUndefined ? 'Please select the product to add the table' : 'Please enter the quantity to add the Table';
                break;
            case 'Buffer Serial Number':
                const isProductString = typeof someProperty['product'].value === 'string';
                title = isProductString ? 'Choose valid Material' : "Provide the selected material's quantity";
                text = isProductString ? 'Please select the material to add the table' : 'Please enter the quantity to add the Table';
                break;
            default:
                break;
        }
        if (title && text) {
            swal({
                title,
                text,
                icon: "warning",
                button: `${t("alerts.ok")}`
            });
        }
    }

    function getRowsData(){
        var items = unique;
        let keys = getKeysYML();
        let lastIndex = items.length - 1;
        return items.map((row, index)=>{
            if(row.ApplicableFrom) {
                return <tr key={index}><RenderRow key={index} data={row} keys={keys}/>
            </tr> 
            }
            else {
                return <tr key={index}><RenderRow key={index} data={row} keys={keys}/>
                {props.commonTitle !== "Vendor Serial Number" || props.commonTitle !== "Reclamation PO" ?  <td>
                <button class="btn btn-outline-danger btn-rounded waves-effect"
                style={{borderRadius:'15px',float:'right',marginRight:'5%'}}
                onClick={ () => deleteRow(index)}>{`${t('delete')}`}</button>
            </td>
                :
               " "
            }
                </tr>
            }
        })
    }

    const RenderRow = (props) => {
        return props.keys.map((key, index)=>{
        return i18n.language === "chi" ? <td key={props.data[key]} >{props.data[key["datafield"]]}</td> : <td key={props.data[key]} >{props.data[key]}</td> 
        })
    }
  
    const deleteRow = (i) => {
        setReadOnly(false)
        swal({title:`${t("alerts.sure")}`, text:`${t("alerts.deleted_not_recovered")}`,
        icon:"warning",
        buttons: [`${t('alerts.cancel')}`,
        `${t('alerts.ok')}`],
         dangerMode: true,
        })        
        .then((willDelete) => {
          if (willDelete) {
            const newArr = [...unique];
            const toRemove =  newArr.splice(i, 1);
            const index = newArr.indexOf(toRemove);
                if (index > -1) { 
                    newArr.splice(index, 1);
                }
            setTableList(newArr);
            swal(`${t("alerts.data_deleted")}`, {
              icon: "success",
              timer: 2000,
              button: false
            });
          } else {
            swal(`${t("alerts.data_safe")}`, {
              timer: 2000,
              button: false
            });
          }
        });
    }
    useEffect(() => {
        if(props.commonTitle === 'Price') 
        uniq = tableList;
            if (props.commonTitle === 'AttributeSets' || props.commonTitle === "Download IOT's(Buffer)") {
            let jsonObject = tableList.map(JSON.stringify);
            let uniqueSet = new Set(jsonObject); 
            let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
            uniq = uniqueArray;
            }
            else if (props.commonTitle === 'Pick List') {
            uniq = tableList.filter(function({delivery_no},index) {
                if((this[delivery_no] != tableList[tableList.length-1].delivery_no))
                return !this[delivery_no] && (this[delivery_no] = delivery_no)
            }, {})
            }
            else if (props.commonTitle === "Buffer Serial Number") {
                uniq = tableList.filter(function({product},index) {
                    if((this[product] != tableList[tableList.length-1].product)){
                        return !this[product] && (this[product] = product)
                    }
                }, {})
            setTdData([])
            }
            else if (props.commonTitle === "Revert Assigned Serial Number") {
                uniq = tableList.filter((e)=>e!=undefined||e!=null)
            }
            else if (props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
                uniq = tableList.filter(function({product},index) {
                    if((this[product] != tableList[tableList.length-1].product)){
                        return !this[product] && (this[product] = product)
                    }
                }, {})
            setTdData([])
            }
            else if (props.commonTitle === "Vendor Serial Number" || props.commonTitle === "Reclamation PO" || props.commonTitle == "Purchase Order") {
                uniq = tableList
            }
            else if(props.title === 'Reclamation Delivery' || props.commonTitle !== "Download IOT's(Buffer)") {
            uniq = tableList.filter(function({material},index) {
                if(this[material] && (this[material] == tableList[tableList.length-1].material))
                swal({title:`${t("alerts.duplicate_values")}`, text:`${t("alerts.material_repeated")}`, icon:"error", button:`${t("alerts.ok")}`})
                return !this[material] && (this[material] = material)
            }, {})
            setTdData([])
            }
        setUnique(uniq);
        setParentTableLength(Object.keys(uniq).length)
        let lastIndex = (Object.keys(uniq).length)-1
        if(lastIndex>=0) {
            if(uniq[lastIndex].ApplicableFrom &&
            uniq[lastIndex].ApplicableFrom >= moment(new Date()).format("MM-DD-YYYY"))
            setDisabled(true);
        }
    }, [tableList]);

    useEffect(() => {
        (async () => {
            setDisabled(false);
            if(props.drpdwnApi === 'not found' || props.drpdwnApi === undefined) {
                for (const [key] of  Object.entries(props.formValue)) {
                    if(key === 'reference_id'){
                        props.formValue[key].value = props.loyaltyRedeem?.referenceNo
                    }
                }
            setloadSForm(false);
            setReleaseNotes('')
            }
            else {
                setModalformValues(props.formValue);
                setloadSForm(true);
                const getdrpdwnresponse = await FetchAPI(props.drpdwnApi);
                const getdrpdwnresponseJson = await getdrpdwnresponse.json();
                setloadSForm(false);
                setForm(getdrpdwnresponseJson)
                const updateForm = {
                    ...props.formValue
                }
                const dropVal = {
                    ...getdrpdwnresponseJson.data
                }
                let obj;
                obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
                    if(updateForm.hasOwnProperty(el)){
                        if(!isEmpty(dropVal[el])){
                            if(updateForm[el].elementType == 'select' || updateForm[el].elementType == 'selectshowlabel' || updateForm[el].elementType == 'selectshowsearch'){
                                if(props.title === 'Reclamation Delivery' && el === 'to_location'){

                                    updateForm[el].elementConfig.options = dropVal['to_locations']
                                }
                                else{
                                    updateForm[el].elementConfig.options = dropVal[el];
                                }
                                if (props.commonTitle === 'IOT Bulk Download' && el === 'vendorId' && !(cookies.get('userRole_name') === 'Super Admin')){
                                    updateForm[el].validate.required = false;
                                }
                                if(updateForm[el].elementType == 'select' || updateForm[el].elementType == 'selectshowlabel'){
                                updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                                if(props.commonTitle === 'Assign Serial Number') {
                                    updateForm['po_mode'].elementConfig.readonly = false
                                }
                                }
                                if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                                updateForm[el].elementConfig.type == 'static2') {
                                    updateForm[el].value = props.val1
                                }
                                /*Rendering The Dynamic Value In Parent field with in "Features List" feature  */
                                if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                                updateForm[el].elementConfig.type == 'static1') {
                                    updateForm[el].value = props.val1    
                            let getURL = updateForm[el].update.endPoint+'?'+el+'='+props.val1;
                                const commanParamVal = new URLSearchParams(commonParams);
                                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                                setModalformValues(updateForm);
                                updateDropDwon(newgetURL, updateForm);
                              }
                /*Rendering The Dynamic Value In Parent field with in "Features List" feature  */
                             
                            }
                            if(updateForm[el].elementType == 'multiselect')
                              updateForm[el].elementConfig.options = dropVal[el];
                        }else
                        {
                            if(updateForm[el].elementType == 'select' )
                            updateForm[el].elementConfig.options = initialValue;
                        }
                    }
                })
                setModalformValues(updateForm);
                setloadSForm(false);
            }
            if((props.titlePreFix == `${t('edit')}` && props.title !== 'Loyalty Redeem') || props.titlePreFix == `${t("view")}` || props.titlePreFix == 'Generate'){
                setloadSForm(true);
                if(props.title == "Location Type"){
                    setloadSForm(false)
                    setLoading(true)
                }
                const getresponse = await FetchAPI(props.getURL);
                const getresponseJson = await getresponse.json();
                setLoading(false)
                setFormInputs(getresponseJson.data)
                if(getresponseJson.data.hasOwnProperty('attributes')) {
                    const responseData1 = getresponseJson.data.attributes;
                    const dropVal1 = {
                        ...responseData1
                    }
                    const updateForm = {
                        ...props.formValue
                    }
                    Object.keys(getresponseJson.data.attributes).forEach((el) => {
                        if(updateForm.hasOwnProperty(el))
                                updateForm[el].value = dropVal1[el];
                    })
                    setModalformValues(updateForm);  
                }
                if(getresponseJson.data.tableData) {
                    setTableList(getresponseJson.data.tableData);
                }
                const responseData = getresponseJson.data;
                const dropVal = {
                    ...responseData
                }
                const updateForm = {
                    ...props.formValue
                }

                if (props.title === 'Build/Software') {
                    let response = Object.values(dropVal)
                    let docdetails;
                    let builddetails;
                    if ("builddetails" in dropVal) {
                        builddetails = { ...response[0] }
                        docdetails = [ ...response[1]]
                        setDocLinks(docdetails)
                        let decodeurl = decodeURIComponent(builddetails['url'])
                        const Url = Object.keys(builddetails).reduce((file, key) => {
                            if(key === 'url'){
                            file.push({ name: decodeurl.substring(decodeurl.lastIndexOf('/')+1)});}
                            return file;
                        }, []);
                        setBuildUrl(Url)
                        let arr1 = []
                        const nameValue = obj => Object.keys(obj).reduce((results, key) => {
                            results.push({ name: key, value: obj[key] });
                            return results;
                        }, []);
                        let zip = nameValue(builddetails)
                        zip.map(function (fValue, id) {
                            arr1[fValue.name] = fValue.value
                        })
                        Object.keys(arr1).map((key) => {
                            if (key === 'platform' || key === "version") {
                                updateForm[key].value = arr1[key]
                            }
                            else if (key === 'release_notes') {
                                setReleaseNotes(arr1[key])
                            }
                            setBuildInputVal(updateForm)
                        })
                    }if("docdetails" in dropVal) {
                        const Url = Object.values(docdetails).reduce((file, fileName, key) => {
                            file.push({name : decodeURIComponent(fileName['file']).substring(decodeURIComponent(fileName['file']).lastIndexOf('/') + 1)});
                            return file;
                        }, []);
                        setDocUrl(Url)
                        Object.keys(staticModalformValues).forEach((key) => {
                            if(key === 'release_doc' && docdetails.length > 0){
                                setChecked(true)
                            }
                        })
                    }
                } 

                if(dropVal['latitude'] !== null &&  dropVal['longitude'] !== null) {
                    setCenter({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setMapPosition({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setMarkerPosition({lat: dropVal['latitude'], lng: dropVal['longitude']})
                    setState(dropVal['state'])
                    setCountry(dropVal['country'])
                    setCity(dropVal['city'])
                    setArea(dropVal['area'])
                    setAddress(dropVal['location_address'])
                }else{
                    setLat(dropVal['latitude'])
                    setLan(dropVal['longitude'])
                    setState(dropVal['state'])
                    setCountry(dropVal['country'])
                    setCity(dropVal['city'])
                    setArea(dropVal['area'])
                    setAddress(dropVal['location_address'])
                }
                
            /* Populate the locations as a DropDown with in the Parent Locations selective I/P Field in "Company Locations" Feature */
                if(updateForm['parent_location'] && dropVal['parentlocations']) {
                    updateForm['parent_location'].elementConfig.options = dropVal['parentlocations'];
                    updateForm['parent_location'].elementConfig.options.splice(0, 0, ...initialValue)
                }
             /*Populate the locations as a DropDown with in the Parent Locations selective I/P Field in "Company Locations" Feature */                                                                            
                let obj;
                if(updateForm['location_id'] && dropVal['locations']) {
                    updateForm['location_id'].elementConfig.options = dropVal['locations'];
                    updateForm['location_id'].elementConfig.options.splice(0, 0, ...initialValue)
                    }
                    obj = Object.keys(getresponseJson.data).forEach((el) => {
                            if(updateForm.hasOwnProperty(el)){
                        updateForm[el].value = dropVal[el];
                        if(updateForm['material'] && dropVal['material_details']) {
                            updateForm[el].elementConfig.options = dropVal['material_details'];
                            updateForm['material'].value = dropVal['material'];
                        }

                    }
                })
                setModalformValues(updateForm);          
                setloadSForm(false);
                setLoading(false);
            }
        })()
    }, []);

    
    const editHandler = (data) => {
        setEdit(data)
    }
    const formInputChangeHandler = (event) =>{
        Object.keys(staticModalformValues).forEach((key) => {
            if(key.includes(event.target.name)){
                if(event.target.type === 'checkbox'){
                    if(event.target.checked == 0){
                    staticModalformValues[key].value = true
                 }else if (event.target.checked == 1){
                 staticModalformValues[key].value = true
                }else{
                    staticModalformValues[key].value = event.target.checked
                }
                setChecked(event.target.checked)
            }
                else if(staticModalformValues.hasOwnProperty('release_notes')){
                    staticModalformValues[key].value = event.target.value
                    setReleaseNotes(event.target.value)
                }
            }
        })
    }

    async function fileUpload(files) {
        setSelectedFile(files)
      }

    const inputModalChangedHandler = (event, inputIdentifier) => {

        const updateOrderForm = {
            ...ModalformValues
        }
        const updateElemetForm = {
            ...updateOrderForm[inputIdentifier]
        };
        if(updateOrderForm[inputIdentifier].elementType === 'radio') {
            updateElemetForm.value=event.target.value
        }
        else if(updateOrderForm[inputIdentifier].elementType === 'switch') {
            updateElemetForm.value=!updateElemetForm.value
        }
        else if(updateOrderForm[inputIdentifier].elementType === 'checkbox') {
            if (cookies.get("customer_id") == 12 && props.title === 'Location' && props.featureTitle === 'Location Types') {
                    updateElemetForm.value = Number(event.target.checked);
            } else {
                if (event.target.checked == 0) {
                    updateElemetForm.value = false;
                } else if (event.target.checked == 1) {
                    updateElemetForm.value = true;
                } else {
                    updateElemetForm.value = Number(event.target.checked);
                }
            }
        }
        else if((updateOrderForm[inputIdentifier].elementType === 'file')) {
            if(event.target.files[0])
                setSelectedFile(event.target.files[0])
        }
        else if(updateOrderForm[inputIdentifier].elementType == 'multiselect'){
            if(Array.isArray(event) && event.length !== 0){
                updateElemetForm.value = event;
            }
        else
            updateElemetForm.value = null;
        }
        else {
            if(updateOrderForm[inputIdentifier].elementType == 'select' || updateOrderForm[inputIdentifier].elementType == 'selectshowlabel' && event.target.value !== `${t('please_select')}`){
                updateElemetForm.value = event.target.value;
                if(props.title === "Loyalty Redeem"){
                    let updatedModalFormValues = {
                        ...ModalformValues
                    }
                    if(event.target.value === "1"){
                        updatedModalFormValues.remarks.label = "Remarks"
                        updatedModalFormValues.remarks.validate.required = false;
                    }else if(event.target.value === "2"){
                        updatedModalFormValues.remarks.label = "Remarks*"
                        updatedModalFormValues.remarks.validate.required = true;
                    }
                    setModalformValues(updatedModalFormValues)
                }
                if(props.commonTitle === 'Category' && cookies.get("customer_id") === "13"){
                let obj = Object.keys(form.data).forEach((el) => {
                    let arrayConvert = [];
                 if(Object.keys(el, updateOrderForm)){
                        form.data['parent_id'].map(function(fValue, indexId){
                            arrayConvert[fValue.value] = fValue.loyaltyValue;
                })
                 }
                 updateOrderForm['loyalty_points'].value = arrayConvert[event.target.value];
                })
            }
            }
            
            else if(updateOrderForm[inputIdentifier].elementType == 'input') {
                updateElemetForm.value = event.target.value;
            }

         else if(updateOrderForm[inputIdentifier].elementType == 'selectshowsearch'){   
            updateElemetForm.value = event;
                if(props.commonTitle == 'Revert Assigned Serial Number' && inputIdentifier === 'po_number'){
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+updateElemetForm.value.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);   
                 }
            if(inputIdentifier === 'label_category'){
                if( event !== '' && updateOrderForm[inputIdentifier].update.required === true){
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event['value'];
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
        }
    }
    if(props.commonTitle ==='Buffer Serial Number'){
        if(inputIdentifier === 'vendorId'||inputIdentifier==='po_number'){
            let getURL =updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.value;
                const commanParamVal = new URLSearchParams(commonParams);
                let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                updateDropDwon(newgetURL, updateOrderForm);
        }
    }
                }
            else if(updateOrderForm[inputIdentifier].elementType == 'textarea'){
                updateElemetForm.value = event.target.value;
                setUnBindValue(event.target.value)
            }
            else
                updateElemetForm.value = null; 
        }
        updateOrderForm[inputIdentifier] = updateElemetForm;
        setModalformValues(updateOrderForm);
        setReason(updateElemetForm.value)
        if(((cookies.get("customer_id") === '13' || cookies.get("customer_id") === '16') && props?.permission === false)&&(inputIdentifier == 'material' || inputIdentifier == 'qty'))
        {
            let val;
            let obj = {};
            val = updateElemetForm.value?.label || updateElemetForm.value
            if(inputIdentifier == 'product' || inputIdentifier == 'material'){
                obj = {
                    product_id: updateElemetForm.value?.value
                }
            }
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        if(props.title === 'Reclamation Delivery'){
            if (inputIdentifier == 'material' || inputIdentifier == 'qty')
            {
                let val;
                val = updateElemetForm.value.label || updateElemetForm.value
                setTdData((tdData) => ({...tdData, [inputIdentifier]:val}));
            }
        }
    
        if((cookies.get("customer_id") === '14' && props.commonTitle === 'Delivery') && (inputIdentifier == 'material' || inputIdentifier == 'qty')){
            let val;
            val = updateElemetForm.value.label || updateElemetForm.value
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val}));
        }
        if((props.commonTitle === "Download IOT's(Buffer)")&&(inputIdentifier == 'material' || inputIdentifier == 'qty' || inputIdentifier == 'po_number'))
        {
                let val1 = updateElemetForm.value.label || updateElemetForm.value
                let val2 = updateOrderForm['po_number'].value
            setTdData((tdData) => ({...tdData, ['po_number']:val2, [inputIdentifier]:val1}));
        }

        if(props.commonTitle === 'Purchase Order' && (inputIdentifier == 'product' || inputIdentifier == 'qty')){
            let val;
            val = updateElemetForm.value?.label || updateElemetForm.value;
            let obj = {};
            if(inputIdentifier == 'product' || inputIdentifier == 'material'){
                obj = {
                    product_id: updateElemetForm.value?.value
                }
            };
            setTdData((tdData) => ({...tdData, [inputIdentifier]:val,...obj}));
        }
        if((props.commonTitle === "Vendor Serial Number" || props.commonTitle == "Reclamation PO"))
        {
            setTableList([]);
            setDisabled(false)
        }
        if((props.commonTitle === "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO")&&(inputIdentifier == 'vendorId'))
        {
            setTableList([]);
        }
        if((props.commonTitle === 'AttributeSets')&&(inputIdentifier == 'location' || inputIdentifier == 'product_group'))
        {
            let val;
            if(inputIdentifier == 'location') {
                let s=updateElemetForm.value.split("(");
                val = s[0]; 
            }
            else
            val = updateElemetForm.value;
            setTdData((tdData) => ({...tdData, [inputIdentifier]: val}));
        }
        if((props.commonTitle === 'Price')&&(inputIdentifier == 'Price' || inputIdentifier == 'ApplicableFrom' || inputIdentifier == 'Remarks'))
        {
            let val = updateElemetForm.value;
            setTdData((tdData) => ({...tdData, [inputIdentifier]: val}));
        }
        if(updateOrderForm[inputIdentifier].elementType == 'select'){
            if(updateOrderForm[inputIdentifier].update.required === true){
                let keyName = event.target.id;
                commonval = {
                    keyName:event.target.value
                }
                if((props.commnTitle === "Revert Assigned Serial Number")&&(inputIdentifier == 'product')){
                }
                if(props.commonTitle ==='Buffer Serial Number'){
                    return
                }
                else if(props.title === 'Reclamation Delivery'){
                    if((inputIdentifier === 'from_location')){
                        let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?location_id='+ cookies.get('userLocation_id');
                            const commanParamVal = new URLSearchParams(commonParams);
                            let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                            updateDropDwon(newgetURL, updateOrderForm);   
                }
                }else if(event.target.value !== '') {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'='+event.target.value;
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);
                }
                else {
                    let getURL = updateOrderForm[inputIdentifier].update.endPoint+'?'+inputIdentifier+'=0';
                    const commanParamVal = new URLSearchParams(commonParams);
                    let newgetURL = (`${getURL}&${commanParamVal.toString()}`);
                    updateDropDwon(newgetURL, updateOrderForm);   
                }
            }
            
        }
        setBuildInputVal(updateOrderForm)
    }

    async function handleFormSubmit() {
        let len;
        let buildFormValues = {}
        if (validator.allValid()) {
            setDisabledButton(true);
            Object.keys(staticModalformValues).forEach((key) => {
                if (key === 'release_notes') {
                    buildFormValues[key] = releaseNotes
                } else if (key === 'release_doc') {
                    buildFormValues[key] = true
                }
                else if (key === 'platform' || key === 'version') {
                    buildFormValues[key] = buildInputVal[key]?.value
                }
            })
            const createFormData = (data) => {
                return Object.keys(data).reduce((formData, key) => {
                    formData.append(key, data[key]);
                    return formData;
                }, new FormData());
            };
            const formData = createFormData({ ...buildFormValues });
            if (props.titlePreFix === 'Edit') {
                formData.append('id',props.editId)
                 formData.append('edit',editProp)
                 formData.append("docEdit",docEdit)
                 formData.append("buildEdit", buildEdit)
                if (editFileUpload === true && edit == "MultiFileUpload") {
                    for (let i = 0; len = buildUrl.length, i < len; i++) {
                        formData.append('File', buildUrl[i])
                    }
                }
                if (edit === "singleFileUpload") {
                     for (let i = 0; len = buildUrl.length, i < len; i++) {
                        formData.append('File', buildUrl[i])
                    }
                    }
                else if (edit === "MultiFileUpload") {
                    for (let i = 0; len = docUrl.length, i < len; i++) {
                        if (docUrl[i]?.lastModified) {
                            formData.append('File', docUrl[i])
                        } 
                          }
                        }
                        
                    }
                    else {
                        for (let i = 0; len = uploadFiles.length, i < len; i++) {
                            formData.append('File', uploadFiles[i])
                        }
                        for (let i = 0; len = multiUploadFiles.length, i < len; i++) {
                            formData.append('File', multiUploadFiles[i])
                        }
                    }
                    setLoading(true)
                    let getresponse = await PostAPI(props.addURL, formData);
                    if(getresponse.status == 200){
                        setLoading(false)
                        if (getresponse?.data.data.status === 409) {
                            setloadSForm(false);
                            setDisabledButton(false);
                            return swal(getresponse.data.data.message, {
                                icon: 'error'
                            })
                        } else {
                            swal("Successfully submitted!", {
                                icon: "success",
                                timer: 2000,
                                button: false
                            });
                            setDisabledButton(true);
                            props.recallMehod();
                            props.hide();
                        }
                    }else{
                        setLoading(false)
                        swal("Something went wrong!", {
                            icon: "warning",
                            timer: 2000
                        });
                    }
                } else {
                    showValidationMessage(true);
                }
            }

    async function updateEndPoint(url,FormVal, someProperty){
        let data = {}
        setloadSForm(true)
        if (props.commonTitle == "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") {
            Object.keys(someProperty).map(el => {
                if((el === 'Primary - Gift Box Quantity') || (el === 'product')) {
                    someProperty[el].value = ''
                }
                })
        data ={...commonParams, ...FormVal, vendorId:someProperty["vendorId"].value}
        } else if (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO') {
            data = {...commonParams,...FormVal}
        }else if (props.commonTitle == "Buffer Serial Number") {
            Object.keys(someProperty).map(el => {
                if((el === 'Quantity') || (el === 'product')) {
                    someProperty[el].value = ''
                
                }
            })
            data = {...commonParams,...FormVal}
        }
        else if((props.commonTitle == 'Delivery' || props.title == 'Reclamation Delivery') && cookies.get("customer_id") !== "13" && cookies.get("customer_id") !== "16"){
            Object.keys(someProperty).map(el => {
                if((el === 'material')|| (el === 'qty')){
                    someProperty[el].value = ''
                }
                })
            data = {...commonParams,
                ...FormVal,
                 from_location:someProperty["from_location"].value,
                 to_location:someProperty["to_location"].value.value.toString(),
                 po_number:someProperty["po_number"].value,
                }
        }else if(props.commonTitle == 'Delivery'){
            Object.keys(someProperty).map(el => {
                if((el === 'material')|| (el === 'qty')){
                    someProperty[el].value = ''
                }
                })
            data = {...commonParams,
                ...FormVal,
                from_location:someProperty['from_location'].value.value
                }
        }else if(props.commonTitle == 'Revert Assigned Serial Number'){ 
            data ={...commonParams, ...FormVal}
        }
         else {
            data ={
            id:cookies.get('customer_id'),
            user_id:cookies.get('user_id'),
            from_location : FormVal['from_location'],
            deliveries : FormVal['deliveries']
            }
        }
        const response = await PostAPI(url,data);
        setloadSForm(false)
         if (response.data.data.status === 409){
            swal(response.data.data.message, {
                icon: "error",
                button:`${t("alerts.ok")}`
            });
        }
             else if (response.data.data.status === 202) {
        swal({
            html: true,
            title: `Inventory not available for :\n ${response.data.data.material}`,
            text : `(Qty - ${parseInt(tdData.qty)}, Inv - ${response.data.data.qty})`,
            icon: "info",
            dangerMode: true,
        })
    }
         else if (response.data.data.status === 201) {
            tdData["material"].map((value) => {
            tdData["material"] = value.label;
            tdData["product_id"] = value.value;
            let tbData1 = { ...tdData };
            setTableList((tableList) => tableList.concat(tbData1));
      });
    }
        else if(response.status == 200){
            let responseDataJson = response.data;
            (props.commonTitle == "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
            :(props.commonTitle == "Revert Assigned Serial Number") ?  setTableList((tableList) => tableList.concat(responseDataJson.data)):
            (props.commonTitle == "Buffer Serial Number") ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
            :(props.commonTitle == 'Delivery') ?  setTableList((tableList) => tableList.concat(responseDataJson.data))
            : (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO') ? setTableList((tableList) => tableList.concat(responseDataJson.data.po_details))
            : setTableList((tableList) => tableList.concat(responseDataJson.data.deliveries));
        }
        else {
            setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                    });
        }
    }

    async function updateDropDwon(URL, FormVal){
        if(props.title == "Location"){
            setLoading(true)
        }
        setloadSForm(true)
        const getdrpdwnresponse = await FetchAPI(URL);
        const getdrpdwnresponseJson = await getdrpdwnresponse.json();
        setLoading(false)
        setloadSForm(false)
        const updateForm = {
            ...FormVal
        }
        const dropVal = {
            ...getdrpdwnresponseJson.data
        }
        let obj;
        obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
            if(Object.keys(el, updateForm)){
                if(updateForm[el].elementType == 'select' && el !== 'po_number'){
                    updateForm[el].value=null;
                    updateForm[el].elementConfig.options = dropVal[el];
                    updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
                    
                    /*To Render value Dynamically within Parent field in Feature Management Feature in Feature Module*/
                    if(updateForm[el].elementConfig.hasOwnProperty('type') &&
                    updateForm[el].elementConfig.type == 'static2') {
                    updateForm[el].value = props.val2
                    }
                    /*To Render value Dynamically within Parent field in Feature Management Feature in Feature Module*/
                }
                else if(updateForm[el].elementType == 'multiselect') {
                    updateForm[el].value =  null
                    updateForm[el].elementConfig.options = dropVal[el];
               }
               else if(updateForm[el].elementType == 'selectshowlabel') {
                        updateForm[el].elementConfig.options = dropVal[el];
                        updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
            }
            else if(updateForm[el].elementType == 'selectshowsearch'){
                updateForm[el].elementConfig.options = dropVal[el];
            }
            }
        })
        setModalformValues(updateForm);
    }
      const handleToggle = () => {
          if (toggle === "Batch Id*") {
              setToggle("Reference Id*");
        }
        if (toggle === "Reference Id*") {
            setToggle("Batch Id*");
        }
      };

      let  clearUnBindValue = () => {
        setUnBindValue('')
      }

    useEffect(() => {
        Object.keys(ModalformValues).forEach((el) => {
            if (props.title === 'Buffer Serial Number' && ModalformValues['po_number'].value !== null) {
                    if (el === 'po_number' && (tableList.length === 1 || tableList.length > 1)) {
                    setPO_number(prev => [...prev, ModalformValues[el].value?.value])
                }
            }
        })
    }, [props.title, (tableList.length && ModalformValues['po_number']?.value)])
      

    async function submitForm(event) {
        event.preventDefault();   
        if(props.commonTitle=='New Notification' || props.commonTitle=='New Template')
        {
            if (validator.allValid()) { 
                swal(`${t("alerts.successfully_submitted")}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                });
                props.hide();
            }else{
                showValidationMessage(true);
            }

        }        else if (props.commonTitle == 'UnBind Serial Number') {
            setDisabled(true)
            let response;
            let dataArray = unBindValue.split('\n');
            if (validator.allValid()) {
                let unbindData = {
                    iot: unBindValue.replace(/\n/g, ","),
                    type: unBind.toggle ? "Gift Box" : "Master Carton"
                }
                if ((/^([A-Za-z0-9]{11}\n)*[A-Za-z0-9]{11}$/).exec(unBindValue) == null) {
                    swal({
                        title: `${t("alerts.11-digit_alpha-numeric_newline")}`,
                        icon: "warning",
                        button: `${t("alerts.ok")}`
                    })
                    setDisabled(false)
                }
                else {
                    if (Boolean(unBind.toggle)) {
                        if (dataArray.length > 500) {
                            swal({
                                title: 'Alert',
                                text: `You are only permitted to Unbind a maximum of 500 Gift Boxes at a time instead of ${dataArray.length}`,
                                icon: "error",
                                button: `${t("alerts.ok")}`
                            })
                            setDisabled(false)
                        }
                        else {
                            response = await PostAPI(props.unBindUrl, unbindData)
                        }
                    }
                    else {
                        if (dataArray.length > 10) {
                            swal({
                                title: "Alert",
                                text: `You are only permitted to Unbind a maximum of 10 Master Cartons at a time instead of ${dataArray.length}`,
                                icon: "error",
                                button: `${t("alerts.ok")}`
                            })
                            setDisabled(false)
                        }
                        else {
                            response = await PostAPI(props.unBindUrl, unbindData)
                        }
                    }
                }
                if (response) {
                    if (response?.data.data.status === 200) {
                        swal(response.data.data.message, {
                            icon: "success",
                            timer: 2000,
                            button: `${t("alerts.ok")}`
                        })
                        setDisabled(false)
                        props.recallMehod();
                        props.hide();
                        setUnBindValue('')
                    } else {
                        setDisabled(true)
                        swal(response?.data.data.message, {
                            icon: "warning",
                            button: `${t("alerts.ok")}`
                        })
                        setDisabled(false)
                    }
                }
            } else {
                setDisabled(false)
                showValidationMessage(true);
            }
        }
        else {
            if((props.table === true && props.commonTitle == 'AttributeSets' && 
            props.titlePreFix == `${t('edit')}`)) {
            if (((parentTableLength == 0 && ModalformValues.location.value != '' 
                && ModalformValues.product_group.value != '') ||
                (parentTableLength > 0 && productgroup && location)) && 
                (props.table === true && props.commonTitle == 'AttributeSets'
                && props.titlePreFix == `${t('edit')}`)) {
                    return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.product_grp_table")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        }
         if((props.table === true && props.commonTitle == 'Delivery' &&
        props.titlePreFix == t("add"))) {
        if (
            ((parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.material.value != '' 
            && ModalformValues.qty.value != ''))
            ) {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.material_table")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == "Download IOT's(Buffer)")) {
        if (
            ((parentTableLength == 0  && ModalformValues.material.value != '' 
            && ModalformValues.qty.value != ''))
            ) {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO') &&
        props.titlePreFix == `${t('add')}`)) {
        if (
            ((parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.po_number.value != '' 
            && ModalformValues.use_type.value != '')  
             && 
            (props.table === true && (props.commonTitle == "Vendor Serial Number" || props.commonTitle == 'Reclamation PO')
            && props.titlePreFix == `${t('add')}`)
            )) {
                 return swal({title:`${t("alerts.po")}`, text:`${t("alerts.fetch")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && props.commonTitle == 'Pick List' && 
        props.titlePreFix == `${t('add')}`)) {
        if (
            parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.deliveries.value != '' 
            && ModalformValues.from_location.value != '')  
            {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
        setloadSForm(false);
        }
        if((props.table === true && (props.commonTitle == "Assign Serial Number" || props.commonTitle === "Reclamation Assign PO") && 
        props.titlePreFix == `${t('add')}`)) {
        if (
            parentTableLength == 0 && props.uniqueid === undefined  && ModalformValues.product.value != '')
            {
                 return swal({title:`${t("alerts.add_table")}`, text:`${t("alerts.add_values")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
            }
    setloadSForm(false);
        }          
        setloadSForm(true);
        if(props.titlePreFix === `${t('import')}` && selectedFile === undefined) {
            setloadSForm(false);
            return swal({title:`${t("alerts.upload_file")}`, text:`${t("alerts.upload_file_mandotory")}`, icon:"warning", button:`${t("alerts.ok")}`}) 
        }
        if(selectedFile) {
            data = new FormData(); 
            data.append('file', selectedFile)
            data.append('customer_id',cookies.get('customer_id'));
            data.append('user_id',cookies.get('user_id'));
            data.append('language',localStorage.getItem('i18nextLng') === 'en' ? 'english' : 'chinese')
            if(ModalformValues['table'])
                data.append('table',ModalformValues['table'].value);
            if(ModalformValues['action'])
                data.append('action',ModalformValues['action'].value);
        }   
        let searchFormDataModified={
            ...commonParams
        };
        let DeliveryExtraParameters = {}
        let revertExtraParameters={}
        for(let inputIdentifier in ModalformValues) {
            if(ModalformValues[inputIdentifier].elementType === 'checkbox') {
                if(ModalformValues[inputIdentifier].value === 0)            
                    searchFormDataModified[inputIdentifier] = false;
                else if(ModalformValues[inputIdentifier].value === 1) 
                    searchFormDataModified[inputIdentifier] = true;
                else
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
            }
            if (customerID.includes(cookies.get("customer_id")) && props.commonTitle === 'Delivery' && ModalformValues[inputIdentifier].elementType === 'selectshowsearch') {
                if (ModalformValues[inputIdentifier].value != null) {
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value.value
                    if (unique) {
                        let materialDataArray = [];
                        unique.forEach((tbRes) => {
                            if (inputIdentifier === 'material') {
                                ModalformValues[inputIdentifier].elementConfig.options.forEach((material) => {
                                    if (material.label === tbRes.material) {
                                        tbRes['product_id'] = material.value;
                                    }
                                })
                            }
                            materialDataArray.push(tbRes)
                        });

                        DeliveryExtraParameters = {
                            customer_type: cookies.get('customer_type'),
                            extra_id: props.extraId,
                            tbData: materialDataArray,
                            address: address,
                            city: city,
                            area: area,
                            state: state,
                            country: country,
                            latitudtableDataArraye: mapPosition.lat == null ? lat : mapPosition.lat,
                            longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                            url: completeURL
                        }
                    }
                }
            }
            else if( props.commonTitle ==='Revert Assigned Serial Number' && ModalformValues[inputIdentifier].elementType === 'selectshowsearch' ) {
                //    For setting po_number data
               if(inputIdentifier == 'po_number'){
                searchFormDataModified[inputIdentifier] = [ModalformValues[inputIdentifier].value]
        }
        //    For setting product and tbData(extraparameters) data
        if(unique){
            let tableDataArray = [];
            let productArray = [];
            unique.forEach((tbRes)=>{
                if(inputIdentifier === 'product'){
                    ModalformValues[inputIdentifier].elementConfig.options.forEach((product)=>{
                        if(product.label === tbRes.product){
                            productArray.push(product);
                            tbRes['pid']= product.value;
                            tableDataArray.push(tbRes)

                        }
                    })
                }
            });
        revertExtraParameters= {
                customer_type: cookies.get('customer_type'),
                extra_id:props.extraId,
                tbData:tableDataArray,
                address: address,
                city: city,
                area: area,
                state: state,
                country: country,
                latitude:  mapPosition.lat == null ? lat : mapPosition.lat,
                longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                url: completeURL
            } 
                searchFormDataModified['product'] = productArray
            }
            }
            else if(ModalformValues[inputIdentifier].elementType === 'selectshowsearch') {
                if ((ModalformValues[inputIdentifier].value) && props.titlePreFix === `${t('edit')}` && Array.isArray(ModalformValues[inputIdentifier].value)) {
                    ModalformValues[inputIdentifier].value.map(function (fValue, indexId) {
                        searchFormDataModified[inputIdentifier] = fValue.value;
                    })
                }
                else if ((ModalformValues[inputIdentifier].value)) {
                    searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value.value;
                }
                else{
                searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
                }
            }
            else if(ModalformValues[inputIdentifier].elementType === 'multiselect') {
                if((ModalformValues[inputIdentifier].value)) {
                    let arrayConvert = [];
                    ModalformValues[inputIdentifier].value.map(function(fValue, indexId){
                        arrayConvert[indexId] = fValue.value;
                    });
                    searchFormDataModified[inputIdentifier] = arrayConvert;
                }
            }
            else{
                if(ModalformValues[inputIdentifier].elementType === 'checkbox') {
                    if (cookies.get("customer_id") == 12 && props.title === 'Location' && props.featureTitle === 'Location Types') {
                        searchFormDataModified[inputIdentifier] = Number(ModalformValues[inputIdentifier].value);
                    }
                } else{
                searchFormDataModified[inputIdentifier] = ModalformValues[inputIdentifier].value;
                }       
            }    
        }
        if(props.commonTitle ==='Buffer Serial Number'){
            unique =  unique.map(e=>{
                let eee ={}
                    let keys = Object.keys(e);
                    keys.map( (key)=>{
                        if(key ==="Primary - Gift Box Quantity" ){
                            eee['primary_qty'] = e[key]
                        }else if(key === 'Secondary - Shipper Carton Quantity'){
                            eee['secondary_qty'] = e[key]
                        }
                        else if(key === 'Total Quantity'){
                            eee['qty'] = e[key]
                        }
                        else{
                            eee[key]=e[key]
                        }
                    })
                    return eee;
                });
        }
        let extraParameters = {
            customer_type: cookies.get('customer_type'),
            extra_id:props.extraId,
            tbData:unique,
            address: address,
            city: city,
            area: area,
            state: state,
            country: country,
            latitude:  mapPosition.lat == null ? lat : mapPosition.lat,
            longitude: mapPosition.lng == null ? lan : mapPosition.lng,
            url: completeURL
        }
        if(props.commonTitle ==='Revert Assigned Serial Number' ){
            extraParameters = revertExtraParameters;
        }
            if (customerID.includes(cookies.get("customer_id")) && props.commonTitle === 'Delivery') {
                extraParameters = DeliveryExtraParameters;
            }
            else {
            extraParameters = {
                customer_type: cookies.get('customer_type'),
                extra_id:props.extraId,
                tbData:unique,
                address: address,
                city: city,
                area: area,
                state: state,
                country: country,
                latitude:  mapPosition.lat == null ? lat : mapPosition.lat,
                longitude: mapPosition.lng == null ? lan : mapPosition.lng,
                url: completeURL
            } 
        }
        if((props.commonTitle === "Entity") && (props.titlePreFix === `${t('add')}`)) {
            searchFormDataModified = {
                ...searchFormDataModified,
                parent_entity_id:props.uniqueid,
                ware_id:props.wareId,
            extraParameters
            }
        }
        else if((props.commonTitle === "Hold") && (props.titlePreFix === `${t('add')}`)){
            searchFormDataModified = {
                ...searchFormDataModified,
                toggle_value:toggle,
            extraParameters
            }  
        }
        else if((props.commonTitle === 'Delivery' || props.commonTitle === "Vendor Info") && (props.titlePreFix === `${t('edit')}`)) {
        for(let inputIdentifier in ModalformValues) {
            if(ModalformValues[inputIdentifier].update?.endPoint){
                if(searchFormDataModified['material'] !== ModalformValues['material'].value.value){
                searchFormDataModified['material'] = ModalformValues['material'].value;
                }else{
                    let arrayConvert = [];
                    arrayConvert.push(ModalformValues['material'].value)
                    searchFormDataModified['material'] = arrayConvert;
                }
                let from_location = {}
                    Object.keys(form.data).forEach(el => {
                        if (el === 'from_location') {
                            form.data[el].forEach((value) => {
                                from_location = value.value
                            })
                        }
                    })
                let searchForm = {
                    id:props.uniqueid,
                    extra_id:props.extraId,
                    material:searchFormDataModified['material'],
                    qty:searchFormDataModified['qty']
                }
                if(formInputs){
                    searchForm = form.data.hasOwnProperty('from_location') ? { ...searchForm, from_location, ...commonParams }
                : { ...searchForm, po_number:formInputs['po_number'] }
                }
              let getURL = ModalformValues[inputIdentifier].update.endPoint
              let getresponse = await PostAPI(getURL,searchForm);
              if(getresponse.status === 200 && getresponse.data.data?.message === undefined){
                  searchFormDataModified = {...searchFormDataModified,
                    po_number:formInputs['po_number']}
                  }
          else if (getresponse.data.data.status === 409 || getresponse.data.data.status === 0){
            setloadSForm(false);
            setDisabledButton(false);
               return swal(getresponse.data.data.message, {
                  icon: "error",
                button:`${t("alerts.ok")}`
              });
          }
            }
            if(ModalformValues[inputIdentifier].elementType === 'selectshowsearch' && Array.isArray(ModalformValues[inputIdentifier].value)) {
                        ModalformValues[inputIdentifier].value.map(function(fValue, indexId){
                            searchFormDataModified[inputIdentifier] = fValue.value;
                            searchFormDataModified = {
                                ...searchFormDataModified,
                                id:props.uniqueid,
                                extraParameters    
                            }
            })
            }else{
                if (inputIdentifier === 'material'){
                    if(typeof searchFormDataModified[inputIdentifier] === 'object'){
                    searchFormDataModified[inputIdentifier].map((material) => {
                        searchFormDataModified[inputIdentifier] = material.value
                    })
                }
            }
            searchFormDataModified = {
                ...searchFormDataModified,
                line:props.line,
                id:props.uniqueid,
                extraParameters    
                }
            }
        }
    } else if ((props.commonTitle === "Parent Category") &&(props.titlePreFix === `${t('edit')}`)){
        extraParameters ={
            ...extraParameters,
            extra_id:props.uniqueid,
        }
        searchFormDataModified = {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters    
                }
            }
            else if(props.commonTitle == 'Download Reclamation PO'){
                searchFormDataModified = {
                        ...searchFormDataModified,
                        id:props.uniqueid,
                        extraParameters    
                }
            }
            else if(props.title === "Loyalty Redeem"){
                searchFormDataModified = {
                    ...searchFormDataModified,
                    loyalty_wallet_transaction_id: props.loyaltyRedeem?.loyaltytransactionid,
                    loyalty_wallet_id: props.loyaltyRedeem?.loyaltyWalletId
                }
            }
        else if ((props.title === "Product Type")) {
            searchFormDataModified = {
                ...searchFormDataModified,
                lookup_category: "Product Types",
            }
        }
        else if(props.title === 'IOT Bulk Download' && !(cookies.get('userRole_name') === 'Super Admin')) {
            let defaultValue
            form.data['vendorId'].map((fvalue,id) => {
                defaultValue = fvalue.value
            })
            searchFormDataModified = {
                ...searchFormDataModified,
                vendorId:defaultValue,
        }
        } else if ((props.title === "UOM")) {
            searchFormDataModified = {
                ...searchFormDataModified,
                manufacture_id: + `${cookies.get("customer_id")}`
            }
        }        
    else {
        searchFormDataModified = {
                ...searchFormDataModified,
                id:props.uniqueid,
                extraParameters    
                }
        }
        let formData = new FormData();
        if(props.title === 'Build/Software'){   
            handleFormSubmit()
        }
        if (validator.allValid() && !props.buildValue) {
            setDisabledButton(true);
            if(props.addURL == undefined) {
                setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 1000,
                    button: false
                });
            }
            let response;
            let getdrpdwnresponseJson1
            if(selectedFile)
                response = await PostAPI(props.addURL, data);
            else if(props.commonTitle === "Download Serial Number" || props.commonTitle === "Download Buffer IOT's" || props.commonTitle == "Download Reclamation PO"){
                let getURL = (`${props.addURL}&reason=${reason}`);
                response =  await FetchAPI(getURL);
                getdrpdwnresponseJson1 = await response.json();
                if(getdrpdwnresponseJson1.data.hasOwnProperty('data')){ 
                    swal(`${t("alerts.successfully_submitted")}`, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    });
                    props.recallMehod();
                    props.hide();
                    window.location.href = getdrpdwnresponseJson1.data.data
                }
                else if(getdrpdwnresponseJson1.data.status === 409){
                    swal(getdrpdwnresponseJson1.data.message, {
                        icon: "warning",
                    })
                }
                else{
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                       timer: 2000,
                       button: false
                       });
                    }
            }
            else if (
                props.commonTitle === "Assign Serial Number" ||
                props.commonTitle === "Assign Buffer Serial Numbers" ||
                props.commonTitle === 'Vendor Serial Number'||
                props.commonTitle === 'IOT Bulk Download'
            ) {     
                try {
                    const res = await PostAPI(props.addURL, searchFormDataModified);
                    if (res.data?.data?.status === 1) {
                        let customText = "Once completed, it will be added to the grid table";
                
                        if (props.commonTitle === 'Vendor Serial Number' || props.commonTitle === "IOT Bulk Download") {
                            customText = "Please wait for 5 minutes while we prepare your data for download.";
                        }
                
                        return swal({
                            title: `Your ${props.commonTitle} request is being processed`,
                            text: customText,
                            icon: "info",
                            closeOnEsc: false,
                            closeOnClickOutside: false,
                        })
                        .then((willProceed) => {
                            if (willProceed) {
                                props.recallMehod();
                                props.hide();
                            } else {
                                setDisabledButton(false);
                            }
                        });
                    } else {
                        setloadSForm(false);
                        setDisabledButton(false);
                           return swal(res.data.data.message, {
                              icon: "warning",
                          button:`${t("alerts.ok")}`
                          });
                      }
                } catch (error) {
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                        timer: 2000,
                        button: false
                    });
                    setDisabledButton(false);
                }
        }
            else if(props.commonTitle === 'Delivery' && props.extraId !== 'Reclamation PO' && props.uniqueid !== undefined && props.titlePreFix === `${t('add')}`){
            for(let inputIdentifier in ModalformValues) {
                if(ModalformValues[inputIdentifier].update?.endPoint){
                        if((ModalformValues["material"].value)) {
                            let arrayConvert = [];
                            arrayConvert.push(ModalformValues['material'].value)
                            searchFormDataModified['material'] = arrayConvert;
                        }
                    let searchForm = {
                        id:props.uniqueid,
                        extra_id:props.extraId,
                        material:searchFormDataModified['material'],
                        qty:searchFormDataModified['qty']
                    }
                    let postData = {...searchForm,
                        po_number:form.data['po_number']
                    }
                  let getURL = ModalformValues[inputIdentifier].update.endPoint
                  let getresponse = await PostAPI(getURL,postData);
                  if(getresponse.status === 200 && getresponse.data.data?.message === undefined){
                      searchFormDataModified = {...searchFormDataModified,
                        po_number:form.data['po_number']}
                           response = await PostAPI(props.addURL, searchFormDataModified);
                         setloadSForm(false);
                    if(isEmpty(response)) {
                         setloadSForm(false);
                         swal(`${t("alerts.something_went_wrong")}`, {
                         icon: "error",
                        timer: 2000,
                        button: false
                        });
                    }
                    else {
                        swal(`${t("alerts.successfully_submitted")}`, {
                            icon: "success",
                            timer: 2000,
                            button: false
                        });
                        setDisabledButton(true);
                    }
                }
                  else if (getresponse.data.data.status === 409){
                    setloadSForm(false);
                    setDisabledButton(false);
                       return swal(getresponse.data.data.message, {
                          icon: "error",
                      button:`${t("alerts.ok")}`
                      });
                  }
                }
                }
            }
            else{
                if(props.title == "Location Type"){
                    setloadSForm(false)
                    setLoading(true)
                }
                response = await PostAPI(props.addURL, searchFormDataModified);
            setloadSForm(false);
            setLoading(false)
            if(isEmpty(response)) {
                setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                });
            }
        }
            if(response?.status == 200 && props.commonTitle !== "Download Serial Number" && props.commonTitle !== "Download Buffer IOT's" && props.commonTitle !== "Download Reclamation PO"){
                if(Object.keys(response.data).length === 1 && response.data.hasOwnProperty('timestamp'))
                {
                    swal({
                        icon: "error",
                        text: "Something went wrong!", 
                       timer: 2000,
                        button: false
                    });  
                }
                else if(props.commonTitle === 'Product Label Mapping' && (response.data.data.status === 200 ||
                    response.data.data.status === 201 )){
                        {swal(response.data.data.message, {
                          icon: "success",
                           timer: 2000,
                           });
                           setDisabledButton(false);
                          }
                          props.recallMehod();
                          props.hide();
                        }
                else if(props.titlePreFix !== `${t('import')}` && response.data.data.status === 409) {
                      swal(response.data.data.message, {
                        icon: "error",
                        button:`${t("alerts.ok")}`
                      });
                      setDisabledButton(false);
                     }
                     else if(props. title === 'Product Type' || props.title === 'UOM'){
                        if(response.data.data.status === 1){
                            swal(response.data.data.message, {
                                icon: "success",
                                timer: 3000,
                                button: true
                            });
                            setDisabledButton(true);
                            props.recallMehod();
                            props.hide();
                        }
                    }
                    else if (props.title === 'Buffer Serial Number') {
                        const { status, message } = response.data.data;
                        let responseBasedIcon = "warning";
                        switch (status) {
                            case 0:
                                responseBasedIcon = "error";
                                break;
                            case 1:
                                responseBasedIcon = "success";
                                break;
                        }
                        const swalOptions = {
                            icon: responseBasedIcon,
                            ...responseBasedIcon === 'success' && { timer: 3000 },
                            ...responseBasedIcon === 'error' && { button: true },
                        };
                        swal(message, swalOptions);
                        setDisabledButton(true);
                        if (responseBasedIcon === "success") {
                            props.recallMehod();
                            props.hide();
                        }
                    }                         
                else if(props.titlePreFix == `${t('import')}` && response.data.data.status === 409) {
                    let msg,msg1;
                    if(response.data.data.message.length > 1) {
                    msg = response.data.data.message.toString();
                    msg1 =msg.split(",Import").join("\nImport")
                    //msg1 =msg;
                    } else
                    msg1 = response.data.data.message[0]
                    swal(msg1, {
                        icon: "error",
                        text: msg1, 
                        button:`${t("alerts.ok")}`
                    });
                    props.hide();
                    props.recallMehod();
                } 
                else {
                    swal(`${t("alerts.successfully_submitted")}`, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    });
                    setDisabledButton(true);
                    if(props.featureTitle == 'Location')
                        props.extracall();
                    props.recallMehod();
                    props.hide();
                   
                }
            }         
            else if(props.commonTitle === "Download Serial Number" || props.commonTitle === "Download Buffer IOT's") {
                swal(`${t("alerts.successfully_submitted")}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                });
                props.recallMehod();
                props.hide();    
            }
            else {
                setloadSForm(false);
                swal(`${t("alerts.something_went_wrong")}`, {
                    icon: "error",
                    timer: 2000,
                    button: false
                    });
            }
        }
        else {
            showValidationMessage(true);
            setloadSForm(false);
        }
        return false;
        }
    }

    async function setActiveTab(e) {
        const commanParamVal = new URLSearchParams(commonParams);
        let URL = props.formValue.downloadSample.update?.endPoint
        let getURL = (`${URL}?${commanParamVal}`);
        setloadSForm(true);
        let response =  await FetchAPI(getURL);
        let getdrpdwnresponseJson1 = await response.json();
        setloadSForm(false);
        let url = Domain + '/' + getdrpdwnresponseJson1.data.slice(7)
        window.location.href = (`${url}`)
    }
    return (
        <div key="Div1">
            <div key="Div2">
            <form>
            <Modal key="ModalK" show={props.showModal} onHide={props.hide} dialogClassName={props.modalWidth} backdrop="static" keyboard={false}>
                <Modal.Header closeButton key="MHeader" className="modal-close-button" >
                    <Modal.Title key="MTitle"> {(props.commonTitle === 'AttributeSets' && props.title1 !== '')  ? props.title1 :  props.titlePreFix }
                        <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                            <strong> {props.title} </strong>
                        </a>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body key="MBody">
                {props.commonTitle === 'Hold' ?
                <label>
                <span 
                id="textSpan" 
                    style={ toggle === "Reference Id*"? { fontWeight: 'normal' } : { fontWeight: 'bold',marginTop:"-7px" } }
                >
                { toggle === "Reference Id*" ? "Batch Id*" : toggle}
                </span>{" "}{" "}
                <Toggle 
                className="custom-classname"
                icons={false}
                checked={toggle === "Reference Id*"} 
                onChange={handleToggle} />
                {" "}<span 
                id="textSpan" 
                    style={ toggle === "Batch Id*"? { fontWeight: 'normal' } : { fontWeight: 'bold' } }
                >
                { toggle === "Batch Id*" ? "Reference Id*" : toggle }
                </span>
                <br></br>
                <br></br>
                </label>:''}
                { (loadSForm) &&
                    <div className='beatLoader-centered'>
                    <div className='spanLoading'>
                        <span>Loading...</span>
                    </div>
                    <BeatLoader />
                </div>
                    }
                <MDBRow key="MDBROW"></MDBRow>
                    {titlesList.includes(props.title) === true && customModalFields(formElementsArray)}
                <MDBRow key="MDBROW"></MDBRow>
                <MDBRow key="MDBROW"></MDBRow>
                {titlesList.includes(props.title) !== true ? 
                        (formElementsArray.map(formElement => (
                        (formElement.config.elementType !== "maps" && formElement.id !== 'template' && formElement.config.elementType !== "textareaMoreHeight"  &&  formElement.config.elementType !== "checkbox") ?
                        <MDBCol md="6" className="mb-6"
                        style={
                            formElement.id === 'batch_id' ? {marginInlineStart:'-53rem'}
                              : formElement.id === 'description' && props.title === 'Product Type'  ? {height:'82px', transform:'translateY(20px)'}
                              : {height:'82px'}}
                        key={formElement.id}>
                            <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={(formElement.config.value == null) ? '' : formElement.config.value}
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                changed={ (event) => inputModalChangedHandler(event, formElement.id)}
                                validater={validator}
                                titlePreFix = {props.titlePreFix}
                                title = {props.title}
                                template = {props.dyn_template}
                                passVal = { passVal }
                                setPassVal = { setPassVal }
                                readonly = {readonly}
                                tableList = {tableList}
                                material={material}
                                setMaterial={setMaterial}
                                qty={qty}
                                fileUpload={fileUpload}
                                setQty={setQty}
                                toggle={toggle}
                                quantity = {quantity}
                                setQuantity = {setQuantity}
                                fromDate={fromDate}
                                setFromDate={setFromDate}
                                toDate={toDate}
                                setToDate={setToDate} 
                                location={location}
                                setLocation={setLocation}
                                product = {product}
                                setProduct={setProduct}
                                productgroup={productgroup}
                                setProductgroup={setProductgroup}   
                                price={price}
                                setPrice={setPrice}
                                remarks={remarks}
                                setRemarks={setRemarks}
                            />   
                            {(props.dyn_template === true  && formElement.config.elementType === 'anchor') ?
                                <span>
                                    <a href="javascript:void(0)" onClick={setActiveTab} >Click to download</a>
                                </span> : ""}   
                            </MDBCol>
                            : (formElement.config.elementType === "checkbox") ? 
                            <MDBCol md="2" className="mb-2" style={{ height: '82px' }}>
                                <InputField
                                    key={formElement.id}
                                    elementType={formElement.config.elementType}
                                    elementConfig={formElement.config.elementConfig}
                                    value={(formElement.config.value == null) ? '' : formElement.config.value}
                                    labelName={formElement.config.label}
                                    id={formElement.config.id}
                                    isValidate={formElement.config.validate}
                                    changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                    validater={validator}
                                    titlePreFix={props.titlePreFix}
                                    title={props.title}
                                />
                            </MDBCol> 
                                :
                            <MDBCol md="12" className="mb-12"  key={formElement.id}>
                             <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={(formElement.config.value == null) ? '' : formElement.config.value}
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                changed={ (event) => inputModalChangedHandler(event, formElement.id)}
                                validater={validator}
                                address={address}
                                city={city}
                                area={area}
                                state={state}
                                country={country}  
                                lat = {lat}  
                                lan = {lan}  
                                mapPosition={mapPosition}
                                markerPosition={markerPosition}   
                                setAddress={setAddress}
                                setLat = {setLat}
                                setLan = {setLan}
                                setCity={setCity}
                                setArea={setArea}
                                setState={setState}
                                setCountry={setCountry}
                                setMapPosition={setMapPosition}
                                setMarkerPosition={setMarkerPosition}    
                                center={center}         
                            />
                        </MDBCol>
                    ))) : ''} 
                    <MDBRow key="MDBROW1"></MDBRow>

                    {props.title === "Build/Software" && <MDBCol>
                    {(props.title === "Build/Software" || props.titlePreFix === 'Edit') ?
                        <div>  
                            <MDBRow>
                                <MDBCol md="3"></MDBCol>
                                    <label for="build" style={{ fontWeight: 300, color: "black",marginLeft:'-117px',marginTop:'14px' }}>Release Build/Software*</label>
                                    <FileUpload setMultiUploadFiles={setMultiUploadFiles}setUploadFiles={setUploadFiles} editResponse = {formInputs} editHandler = {editHandler} titlePreFix = {props.titlePreFix} buildInputVal={buildInputVal}
                                        setBuildUrl={setBuildUrl} setEditFileUpload={setEditFileUpload}  setEditProp={setEditProp} setBuildEdit={setBuildEdit} setChecked={setChecked} ModalformValues={ModalformValues} buildUrl={buildUrl}/>
                                    <FileList uploadFiles={uploadFiles} buildUrl={buildUrl} titlePreFix = {props.titlePreFix} removeFile={removeFile} />
                                    </MDBRow>
                            <MDBRow>
                                <MDBCol md="3"></MDBCol>
                                    <label for="release_notes" style={{ fontWeight: 300, color: "black",margin: "0 -19%"}}>Release Notes</label>
                                    <MultiFileUpload multiUploadFiles={multiUploadFiles} setMultiUploadFiles={setMultiUploadFiles}  editHandler = {editHandler} docUrl={docUrl} setDocUrl={setDocUrl}  setEditProp={setEditProp} setDocEdit={setDocEdit} buildInputVal={buildInputVal}/>
                                    <MultiFileList multiUploadFiles={multiUploadFiles} docUrl={docUrl} editResponse = {formInputs} titlePreFix = {props.titlePreFix} removeFile={removeFile} />
                             </MDBRow>
                        </div> : ""
                        }
                                
                    </MDBCol>}
                    {(props.table === true) && ((props.commonTitle === 'Delivery'|| props.commonTitle === 'Buffer Serial Number' || props.commonTitle === 'Pick List' || props.commonTitle === "Revert Assigned Serial Number" || props.commonTitle === "Assign Serial Number"  || props.title == 'Reclamation Delivery'? props.titlePreFix == `${t('add')}` && props.uniqueid === undefined : null) || 
                        props.commonTitle == 'AttributeSets' || props.commonTitle == "Purchase Order" || props.commonTitle === "Reclamation Assign PO" || (props.commonTitle == 'Price' && props.titlePreFix == `${t('edit')}`))
                        ?
                        <MDBRow className='d-flex align-items-center mb-4'>
                        {(props.commonTitle == 'Price' && props.titlePreFix == `${t('edit')}`
                        && unique[0].ApplicableFrom < moment(new Date()).format("YYYY-MM-DD")) 
                            ?
                        <div className='text-center mb-3 row'>
                            <button 
                            disabled="true"
                            onClick={ () => addTableData(ModalformValues) }
                            class="btn btn-outline-primary btn-rounded waves-effect"
                            style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%'}}
                            >{`${t('add_table')}`}</button>
                        </div>
                        :
                        <div className='text-center mb-3 row'>
                            {(props.commonTitle === "Vendor Serial Number" ?
                                <button 
                                onClick={ () => addTableData(ModalformValues) }
                                class="btn btn-outline-primary btn-rounded waves-effect"
                                style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%',fontSize:'x-small'}}
                                >{`${t('fetch_data')}`}</button>
                                :
                            <button 
                            onClick={ () => addTableData(ModalformValues) }
                            class="btn btn-outline-primary btn-rounded waves-effect"
                            style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%'}}
                            >{`${t('add_table')}`}</button>
                            )}
                        </div>
                    }
                            {/* <div className='text-center mb-3 row'>
                                <button 
                                onClick={ () => addTableData(ModalformValues) }
                                class="btn btn-outline-primary btn-rounded waves-effect"
                                style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%'}}
                                >Add Table</button>
                            </div> */}
                        </MDBRow>
                    :''}
                    <MDBRow key="MDBROW1"></MDBRow>
                    <MDBRow className='d-flex align-items-center mb-4'>
                    {(props.commonTitle === "Vendor Serial Number" || props.commonTitle === "Reclamation PO" && props.titlePreFix == `${t('add')}` && tableList == 0) ?
                    <button
                    disabled={disabled}
                    onClick={ () => addTableData(ModalformValues) }
                    class="btn btn-outline-primary btn-rounded waves-effect"
                    style={{borderRadius: '15px',width: '13%',float:'right',marginRight:'5%',fontSize:'x-small'}}
                    >{`${t('fetch_data')}`}</button>
                    : ""}
                    </MDBRow>
                    {(unique && (unique.length> 0))  ? 
                        <Table striped hover >
                            <thead>
                            <tr>{getHeader()}</tr>
                            </thead>
                            <tbody>    
                            {getRowsData()}
                            </tbody>
                        </Table>
                   : ''}
                       
                </Modal.Body>
                <Modal.Footer key="MFooter" style={props.title ===  'UnBind Serial Number' ? {transform :'translateY(24px)'} : null}>
                
                {(props.title ===  'UnBind Serial Number') ? '' :
                    <MDBRow key="MDBROW2" className='d-flex align-items-center mb-4'>
                    
                        <div className='text-center mb-3 row'>
                        {(props.titlePreFix == `${t("view")}` && props.commonTitle == 'IOT')
                        ? ''
                        :(props.commonTitle === 'Hold') ?
                        <ButtonField submit={ submitForm } color="primary" BName="Hold"/>
                        :<ButtonField disabled={disabledButton} submit={ submitForm } color="primary" BName= { (props.titlePreFix == `${t('edit')}` || (props.titlePreFix == t("add") && props.commonTitle !== "Vendor Serial Number")) ? props.title === "Loyalty Redeem" ? "Submit" : `${t('save')}` : (props.titlePreFix == t("add") && props.commonTitle == "Vendor Serial Number" || props.titlePreFix === t('enter') || props.titlePreFix === t("update") || props.titlePreFix === t("import") || props.commonTitle === "Download IOT's" || props.commonTitle === "Download IOT's(Buffer)" || props.commonTitle === "Download Buffer IOT's" || props.commonTitle == "Download Serial Number" || props.title == "Download Reclamation PO") ? `${t('submit')}` : `${t('modal_add')}` } />}
                        <ButtonField submit={props.hide} color="danger" BName={`${t('close')}`} />
                        {(loading===true)&& <div style={{position: "absolute",top: "35%",left: "47%",zIndex: 1}}><BeatLoader color={"#3C423C"} /></div>}
                        </div>
                    </MDBRow>}
                </Modal.Footer>
            </Modal>
            </form>
            </div>
        </div>
    );
}

export default ModalBox;